import React, { useState } from "react";
import {
  Grid, Paper, Typography, Box, Stack, Switch, FormControlLabel, TextField, Button, Chip, Divider
} from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function AutomationsTab() {
  const [rules, setRules] = useState({
    autoTaskNoReply: true,
    noReplyMinutes: 10,
    autoReengage: true,
    reengageDays: 3,
    autoAssignRoundRobin: true,
    autoCreateAgendaOnStage: false,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Card title="Automações SDR" subtitle="Criação de tarefas, reengajamento e regras por etapa">
          <Stack spacing={2}>
            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={rules.autoTaskNoReply}
                    onChange={(e) => setRules((p) => ({ ...p, autoTaskNoReply: e.target.checked }))}
                  />
                }
                label="Criar tarefa automática quando lead ficar sem resposta"
              />
              <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} sx={{ mt: 1 }}>
                <TextField
                  label="Minutos sem resposta"
                  type="number"
                  value={rules.noReplyMinutes}
                  onChange={(e) => setRules((p) => ({ ...p, noReplyMinutes: Number(e.target.value) }))}
                  size="small"
                  sx={{ width: { xs: "100%", md: 220 } }}
                  disabled={!rules.autoTaskNoReply}
                />
                <Chip
                  label={`SLA alvo: ${rules.noReplyMinutes} min`}
                  sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--bg)" }}
                />
              </Stack>
            </Box>

            <Divider />

            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={rules.autoReengage}
                    onChange={(e) => setRules((p) => ({ ...p, autoReengage: e.target.checked }))}
                  />
                }
                label="Reengajar automaticamente leads parados"
              />
              <Stack direction={{ xs: "column", md: "row" }} spacing={1.5} sx={{ mt: 1 }}>
                <TextField
                  label="Dias sem interação"
                  type="number"
                  value={rules.reengageDays}
                  onChange={(e) => setRules((p) => ({ ...p, reengageDays: Number(e.target.value) }))}
                  size="small"
                  sx={{ width: { xs: "100%", md: 220 } }}
                  disabled={!rules.autoReengage}
                />
                <Chip
                  label={`Janela: ${rules.reengageDays} dias`}
                  sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--bg)" }}
                />
              </Stack>
            </Box>

            <Divider />

            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={rules.autoAssignRoundRobin}
                    onChange={(e) => setRules((p) => ({ ...p, autoAssignRoundRobin: e.target.checked }))}
                  />
                }
                label="Distribuir leads automaticamente (round-robin)"
              />
              <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.5 }}>
                Depois a gente adiciona: por canal, por horário, por prioridade.
              </Typography>
            </Box>

            <Box>
              <FormControlLabel
                control={
                  <Switch
                    checked={rules.autoCreateAgendaOnStage}
                    onChange={(e) => setRules((p) => ({ ...p, autoCreateAgendaOnStage: e.target.checked }))}
                  />
                }
                label="Ao entrar em 'Agendamento', sugerir criação de compromisso na Agenda"
              />
            </Box>
          </Stack>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => alert("Salvar automações (futuro)")}
            >
              Salvar automações
            </Button>
          </Stack>
        </Card>
      </Grid>

      <Grid item xs={12} md={5}>
        <Card title="Exemplos prontos" subtitle="Pra você ver o que entra aqui">
          <Stack spacing={1}>
            <Chip label="Lead novo → criar tarefa 'Primeiro contato'" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
            <Chip label="Sem resposta 10min → tarefa + alerta" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
            <Chip label="Agendamento → confirmação + lembrete" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
            <Chip label="Perdido → registrar motivo de perda" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--branco)" }} />
          </Stack>

          <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 2 }}>
            Quando plugar no Firebase, isso vira regras reais com toggles e condições.
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
}